import { useEffect, useState } from 'react';

import { DateTime } from 'luxon';

import { useGetMyTaskSubmissionQuery } from '@school_ify/schoolify-repository/src/student/types';

import Card from 'components/Card/Card';
import { useAppSelector } from 'redux/hooks';
import { selectUserData } from 'redux/editProfile/userProfile.slices';
import RenderWithRole from 'hoc/renderWithRole';

import AssignmentSubmissionDetails from '../Study/components/AssignmentSubmissionDetails';
import SubmitAssignment from '../Forms/SubmitAssignment';

import './assigmentDetails.scoped.scss';
import { useTranslation } from 'react-i18next';

const TASK = ({ study, handleModal }) => {
  const user = useAppSelector(selectUserData);
  const { t } = useTranslation();
  const [model, setModel] = useState({
    text: '',
    files: [],
    assignment_id: study.id,
    user_id: user?.id,
    is_submited: false,
    id: null,
    completed_at: '',
  });
  const { data, loading, refetch } = useGetMyTaskSubmissionQuery({
    variables: {
      assignment_id: study.id, // value for 'assignment_id'
      user_id: user?.id, // value for 'user_id'
    },
    fetchPolicy: 'network-only',
  });

  function setModalPropsFromAPICall(apiData) {
    if (!apiData.assignment_submits[0]) {
      return;
    }
    const item = apiData.assignment_submits[0];
    setModel({
      text: item.content,
      files: item.files,
      assignment_id: study.id,
      user_id: user.id,
      is_submited: item.is_submited,
      id: item.id,
      completed_at: item.completed_at,
    });
  }

  const refetchData = async () => {
    refetch({
      assignment_id: study.id, // value for 'assignment_id'
      user_id: user?.id, // value for 'user_id'
    }).then(res => setModalPropsFromAPICall(res.data));
  };

  useEffect(() => {
    if (loading) {
      return;
    }
    setModalPropsFromAPICall(data);
  }, [loading]);
  // TODO Add modal call for grades
  return (
    <>
      <Card>
        <Card.Header>
          <h4>{study && study.title}</h4>
        </Card.Header>
        <Card.Body>
          <div className="text flex gap-1 mb-1">
            <span>
              <span className="text-bold">{t('common:Date')}:</span>{' '}
              {DateTime.fromISO(study.due_at).toFormat('DD')}
            </span>
            <span>
              <span className="text-bold">{t('live_classes:Start-Time')}:</span>{' '}
              {DateTime.fromISO(study.due_at).toFormat('HH:mm')}
            </span>
          </div>
          <label className="text-bold block mt-1">{t('common:add_task_desc')}</label>
          {study && (
            // ql-editor class is really important
            <div
              className="ql-editor p-0"
              style={{ padding: 0 }}
              dangerouslySetInnerHTML={{
                __html: study.description,
              }}
            />
          )}

          {!study && <h1>Select study</h1>}

          {RenderWithRole({
            teacher: (
              <button
                onClick={() => handleModal()}
                className="btn bg-white rounded-full shadow border-none"
              >
                {t('common:Grades')}
              </button>
            ),
          })}
        </Card.Body>
      </Card>
      <div className="mt-1">
        {RenderWithRole({
          student: !model.is_submited ? (
            <SubmitAssignment model={model} callback={refetchData} />
          ) : (
            <AssignmentSubmissionDetails model={model} />
          ),
        })}
      </div>
    </>
  );
};

export default TASK;
